import khDog from './kh-dog.svg'

export const isFetching = state => state.clientBranding.isFetching
export const isUpdating = state => state.clientBranding.isUpdating

export const getClientLogo = state => state.clientBranding.data.logo.contentUrl ?? khDog
